// @ts-check
import { filter, isNil, groupBy, mapValues } from "lodash";

export const getForecastMacroAllocations = ({
  macroAllocations,
  allocationProjectLookup,
  groupedByDemand,
}) => {
  const validMacroAllocations = filter(
    macroAllocations,
    (ma) => allocationProjectLookup[ma.allocationProjectId]
  );

  const groupedMacroAllocations = mapValues(
    groupBy(validMacroAllocations, (ma) =>
      groupedByDemand ? ma.targetGroupId : ma.sourceGroupId
    ),
    (partiallyGroupedMacroAllocations) => {
      return groupBy(partiallyGroupedMacroAllocations, (ma) =>
        groupedByDemand ? ma.sourceGroupId : ma.targetGroupId
      );
    }
  );
  return groupedMacroAllocations;
};

export const getPlannerMacroAllocations = ({
  macroAllocations,
  allocationProjectLookup,
  includeNullStatus = true,
  groupedByDemand,
}) => {
  const validMacroAllocations = filter(
    macroAllocations,
    (ma) =>
      allocationProjectLookup[ma.allocationProjectId] &&
      (includeNullStatus ||
        !isNil(ma.approvalStatus) ||
        !isNil(ma.requestStatus))
  );

  const groupedMacroAllocations = mapValues(
    groupBy(validMacroAllocations, (ma) =>
      groupedByDemand ? ma.targetGroupId : ma.sourceGroupId
    ),
    (partiallyGroupedMacroAllocations) => {
      return groupBy(partiallyGroupedMacroAllocations, (ma) =>
        groupedByDemand ? ma.sourceGroupId : ma.targetGroupId
      );
    }
  );

  return groupedMacroAllocations;
};
